<template>
    <div>
        <div id="mi_theysay_control">
            <div class="left">
                <a @click="toggle" class="pointer"><span>Conteúdo Programático Modular</span>&nbsp;&nbsp;{{show_title}}</a>
            </div>
        </div>
        <div id="mi_theysay" :class="{active:isShowing}">
            <div id="mi_theysay_add" v-show="isAdding">
                <v-text-field label="Título" v-model="current.title"></v-text-field>
                <button class="fluke-btn" @click="add(index != undefined ? index : 'undefined')">Salvar</button>
                <button class="fluke-btn fluke-grey" @click="cancel">Cancelar</button>
            </div>
            <div id="mi_theysay_list" v-show="list.length && !isAdding">
				<table>
					<thead>
						<tr>
                            <th>&nbsp;</th>
							<th>Título</th>
                            <th>&nbsp;</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in list" v-bind:key="index" :set="isViewSub[index] = false">
                            <td>
                                <button class="flake-btn" @click="edit_enable(item, index)"><i class="material-icons">edit</i></button>
                                <button class="flake-btn" @click="remove(index)"><i class="material-icons">delete</i></button>
                            </td>
							<td>{{item.title}}</td>
                            <td>
                            </td>
						</tr>
					</tbody>
				</table>
            </div>
            <div id="mi_theysay_add_button" v-show="!isAdding">
                <button class="fluke-btn" @click="add_enable">Adicionar</button>
            </div>
        </div>
    </div>
</template>

<script>
import mi from './mi.js';

export default {
    mixins: [
        mi
    ],
    data: function(){
        return {
            current: {
                title: '',
                items: [{
                    title:''
                }]
            },
            itemSub: [{
                title:''
            }]
        }
    },
    methods: {
        add_enable: function()
        {
            this.current = {
                title: '',
                items: []
            }
            this.isAdding = true;
            this.index = undefined;
        },
        add_sub_enable: function(item,index){
            this.isAddSub.forEach(function(key){
                this.isAddSub[key] = false;
            });

            this.itemSub = item;
            //this.addSub[index] = true;

            this.isAddSub[index] = true;
        },
        view_sub_enable: function(item,index){
            if(this.isViewSub.length > 0){
                for(var i = 0;i < this.isViewSub.length; i++){
                    this.isViewSub[i] = false;    
                }
            }
            this.itemSub = item.items != undefined ? item.items : 0;

            this.isViewSub[index] = true;
        },
        edit_enable: function(item, index){
            this.current = item;
            this.index = index;
            this.isAdding = true;
        }
    }
}
</script>